import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { LIGHT_BLUE, WHITE, GREY, APP_TEMA } from '../../styles/color';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15%;
  gap: 20px;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 576px) {
    margin-top: 10%;
    padding: 0 20px;
  }
`;

export const MenuCategory = styled.div`
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

export const MenuCategoryTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #007ACC;
  }
  
  &.open {
    background-color: #007ACC;
    border-radius: 10px 10px 0 0;
  }
  
  .toggle {
    font-size: 20px;
    font-weight: bold;
  }
`;

export const CategoryIcon = styled.span`
  font-size: 20px;
  margin-right: 10px;
`;

export const SubMenuList = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  border-radius: 0 0 10px 10px;
`;

export const SubMenuLink = styled(Link)`
  padding: 12px 20px 12px 50px;
  text-decoration: none;
  color: #333;
  font-size: 15px;
  border-bottom: 1px solid ${GREY};
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: ${APP_TEMA};
    color: ${WHITE};
  }
  
  @media (max-width: 576px) {
    padding: 10px 15px 10px 40px;
    font-size: 14px;
  }
`;
